module.exports = __webpack_public_path__ + "static/img/Matt_Crouch_desktop.b1702b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Matt_Crouch_desktop.jpg
// module id = ez2Q
// module chunks = 0